import { render } from "./DesignTeam.vue?vue&type=template&id=2577f056"
import script from "./DesignTeam.vue?vue&type=script&lang=js"
export * from "./DesignTeam.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__